import { createAction } from '@reduxjs/toolkit';
export const FETCH_MESSAGE_SUMMARY = 'FETCH_MESSAGE_SUMMARY';
export const fetchMessageSummaryAction = createAction(FETCH_MESSAGE_SUMMARY, (messageSessionId) => ({
  payload: { messageSessionId }
}));